angular.module('dentalLinks')
  // Formats a byte count as a short human-readable size for the CBCT strip
  // summary, e.g. 5242880 -> "5 MB", 1610612736 -> "1.5 GB". (DCL-211)
  .filter('cbctFileSize', function () {
    var UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

    return function (bytes) {
      var size = Number(bytes);
      if (!isFinite(size) || size <= 0) {
        return '0 B';
      }
      var unit = 0;
      while (size >= 1024 && unit < UNITS.length - 1) {
        size = size / 1024;
        unit++;
      }
      // One decimal below the GB range reads as noise; keep it for GB/TB only.
      var rounded = unit >= 3 ? Math.round(size * 10) / 10 : Math.round(size);
      return rounded + ' ' + UNITS[unit];
    };
  });
